import { Checkbox, Collapse, Grid, IconButton, TableCell, TableRow } from '@mui/material';
import { FilterableTableColumn } from './FilterableTable';
import { ExpandMore } from '@material-ui/icons';
import { useState } from 'react';
interface FilterableTableRowProps {
  row: any;
  columns: FilterableTableColumn[];
  children?: any;
  selectable?: boolean;
  selected?: boolean;
  primaryKey?: string;
  /* eslint-disable */
  onSelectChange?: (id: any, selected: boolean) => void;
  onClick?: (row: any) => void;
  /* eslint-enable */
}
export default function FilterableTableRow({
  columns,
  row,
  children,
  selectable,
  selected,
  primaryKey,
  onSelectChange,
  onClick,
}: FilterableTableRowProps) {
  const extendable = Boolean(children);
  const [isOpen, setOpen] = useState(false);
  // useEffect(() => {
  //   setOpen(false);
  // }, [row]);
  const handleSelectClick = (e: any) => {
    e.stopPropagation();
    if (onSelectChange && primaryKey) onSelectChange(row[primaryKey], !selected);
  };
  const handleClick = (e: any) => {
    if (onClick) {
      e.stopPropagation();
      onClick(row);
    }
  };
  const handleExpandClicked = () => {
    if (!extendable) return;
    setOpen(!isOpen);
  };

  return (
    <>
      <TableRow
        className={`${extendable ? 'extendable-table-row' : ''}${isOpen ? ' extended' : ''}${
          onClick ? ' clickable' : ''
        }`}
        onClick={onClick ? handleClick : handleExpandClicked}
      >
        {selectable && (
          <TableCell width={32}>
            <Checkbox onClick={handleSelectClick} checked={selected === true} />
          </TableCell>
        )}
        {columns.map((column, colIndex) => (
          <TableCell width={column.fixWidth} key={colIndex}>
            {column.render !== undefined ? column.render(row) : row[column.field]}
          </TableCell>
        ))}
        {extendable && (
          <TableCell style={{ textAlign: 'right' }}>
            <IconButton size="small" onClick={handleExpandClicked} className="row-extend-button">
              <ExpandMore className={isOpen ? 'is-open' : undefined} />
            </IconButton>
          </TableCell>
        )}
      </TableRow>
      <TableRow className="extended-row">
        <TableCell colSpan={columns.length + 1 + (selectable ? 1 : 0)}>
          <Collapse in={isOpen}>
            <Grid container p={2} pt={0}>
              {children}
            </Grid>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
